import { jsx as _jsx } from "react/jsx-runtime";
const makeStyle = (orientation, width) => orientation === 'row' && width ? { width: `${width}%` } : { flex: 1 };
const RecordColumn = ({ children, first, last, legend, orientation, width, }) => {
    const classNames = [
        'items-center',
        'bg-record-background-color',
        'text-record-text-color',
        'flex',
        'flex-row',
        'justify-center',
        'place-items-center',
        'last:!border-tr-none',
        'last:rounded-bl',
        'last:rounded-br',
    ];
    if (orientation === 'column') {
        classNames.push('border-t');
        classNames.push('border-record-border-color');
    }
    if (orientation === 'column')
        classNames.push('p-2');
    if (orientation === 'row') {
        classNames.push('first:py-2');
    }
    if ((first && legend) || orientation === 'column') {
        classNames.push('first:!rounded-tl');
    }
    if (orientation === 'column') {
        classNames.push('first:!rounded-tr');
    }
    if (last && !legend && orientation === 'row') {
        classNames.push('first:!rounded-bl');
    }
    if (last && legend)
        classNames.push('last:!rounded-tr');
    if ((last && !legend) || orientation === 'column') {
        classNames.push('last:!rounded-bl');
    }
    if ((last && !legend) || orientation === 'column') {
        classNames.push('last:!rounded-br');
    }
    return (_jsx("li", { style: makeStyle(orientation, width), className: classNames.join(' '), children: children }));
};
export default RecordColumn;
